module.exports = __webpack_public_path__ + "media/application/images/svgs/undo-f36c9bae4959205b75aa3566ebfb9f15.svg";